/** Debe coincidir con server/src/utils/seedVisibility.js (DEMO_TENANT_SLUGS). */
const DEMO_TENANT_SLUGS = new Set(['default', 'acero']);

function demoTenantSlugOf(record) {
    return String(record?.slug ?? record?.tenant_slug ?? record?.tenantSlug ?? '')
        .trim()
        .toLowerCase();
}

export function isDemoTenant(record) {
    if (!record) return false;
    if (record.is_demo === true || record.is_demo === 1) return true;
    const slug = demoTenantSlugOf(record);
    return slug !== '' && DEMO_TENANT_SLUGS.has(slug);
}

export function isEmployeeInDemoTenant(record) {
    return isDemoTenant(record);
}

/** @deprecated Alias; usar isEmployeeInDemoTenant. */
export function isSeedEmployee(record) {
    return isEmployeeInDemoTenant(record);
}

export function applyEmployeeListVisibility(employees, { seedDataVisible, viewerRole, tenantSlug } = {}) {
    if (!Array.isArray(employees)) return employees;
    const contextSlug = demoTenantSlugOf({ tenant_slug: tenantSlug, slug: tenantSlug });

    let list = employees;

    if (!seedDataVisible) {
        if (contextSlug && DEMO_TENANT_SLUGS.has(contextSlug)) {
            list = [];
        } else if (!contextSlug) {
            list = list.filter((e) => !isEmployeeInDemoTenant(e));
        }
    }

    if (viewerRole !== 'superadmin') {
        list = list.filter((e) => e.role !== 'superadmin');
    }
    return list;
}

export function applyAlertListVisibility(alerts, seedDataVisible) {
    if (!Array.isArray(alerts) || seedDataVisible) return alerts;
    return alerts.filter((a) => {
        const code = String(a?.alert_code ?? a?.alertCode ?? '');
        return !code.startsWith('SEED_DEMO_');
    });
}
